import { render, staticRenderFns } from "./TransfersFilters.vue?vue&type=template&id=3172761a&scoped=true&"
import script from "./TransfersFilters.vue?vue&type=script&lang=js&"
export * from "./TransfersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3172761a",
  null
  
)

export default component.exports